/**
 * Parse a date-only string (YYYY-MM-DD or ISO) as a local calendar date.
 * Avoids UTC midnight shift from `new Date("YYYY-MM-DD")`.
 */
export function parseDateOnlyLocal(
  dateString: string | null | undefined,
): Date | null {
  if (!dateString) return null;
  const dateOnly = dateString.slice(0, 10);
  const [y, m, d] = dateOnly.split("-").map(Number);
  if (y == null || m == null || d == null || isNaN(y) || isNaN(m) || isNaN(d))
    return null;
  const localDate = new Date(y, m - 1, d);
  if (isNaN(localDate.getTime())) return null;
  return localDate;
}

/**
 * Format a date-only string (YYYY-MM-DD or ISO) for display without timezone shift.
 * new Date("1990-05-15") is interpreted as UTC midnight, so toLocaleDateString()
 * can show the previous day in western timezones. Parsing as local date avoids that.
 */
export function formatDateOnlyForDisplay(
  dateString: string | null | undefined,
): string {
  const localDate = parseDateOnlyLocal(dateString);
  if (!localDate) return "N/A";
  return localDate.toLocaleDateString();
}

/** Local calendar day as YYYY-MM-DD for date-only comparisons. */
export function getLocalTodayDateOnly(): string {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}
